<template>
  <div class="app-container" id="漫调资讯">
    <div class="home-bg bg-image"></div>
    <div class="business-boxing" id="资讯">
      <div class="business-border" id="活动">
        <information-center></information-center>
      </div>
      <div style="width: 100%;display: flex;justify-content: center;align-items: center">
        <div class="article-container">
          <div v-if="tableData.length > 0">
            <div class="title-container" v-for="item in tableData" :key="item.id" @click="linkTo(item)">
              <div class="title">{{item.xTitle}}</div>
              <div class="time">{{item.xTime}}</div>
            </div>
          </div>
          <div v-else style="display: flex; align-items: center; justify-content: center; flex-direction: column; height: 100%">
            <div class="empty-text">暂无数据</div>
          </div>
          <div class="pagination-div">
            <pagination :small="isPhone === 'phone'" hide-on-single-page background layout="prev, pager, next" :total="totalNum" :page-size="10" @current-change="getValue"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleScrollToAnchor, isMobile } from '@/util/tool'
import { informationTypes } from '@/common-data/information'
import InformationCenter from '@/components/common/information-center.vue'
import { Pagination } from 'element-ui'

export default {
  components: { InformationCenter, Pagination },
  name: 'information',
  data () {
    return {
      activeName: '资讯',
      hasMounted: false,
      tableData: [],
      isPhone: '',
      menus: informationTypes,
      totalNum: undefined,
      currentPage: 1,
      queryParams: {
        current: 1,
        size: 10
      }
    }
  },
  props: {
    jumpName: {
      type: String
    }
  },
  watch: {
    jumpName: {
      handler (val) {
        if (this.hasMounted && val) this.handleScrollToAnchor(val)
      },
      immediate: true
    }
  },
  created () {
    this.isPhone = this.isMobile()
    this.getData()
  },
  mounted () {
    this.hasMounted = true
    if (this.jumpName) {
      this.handleScrollToAnchor(this.jumpName)
    }
  },
  methods: {
    isMobile,
    async getData (params) {
      const { current, size } = this.queryParams
      const res = await this.$req.get(`/app/OffwebNews/newlist?current=${current}&size=${size}`, { params })
      this.tableData = res.data.content
      this.totalNum = res.data.totalElements
    },
    handleScrollToAnchor,
    checkMenu (item) {
      this.activeName = item.name
      const classifyId = item.id
      this.getData({ classifyId })
    },
    async getValue (val) {
      this.queryParams.current = val
      await this.getData()
    },
    linkTo (item) {
      window.open(item.xUrl, '_blank')
    }
  }
}
</script>
<style scoped lang="less">
@import "@/assets/styles/common.css";
/* 基础样式 - 适用于所有设备 */
.bg-image{
  background: url('https://imandiao.oss-cn-beijing.aliyuncs.com/website/images/information/background.png') no-repeat center;
  background-size: cover;
  object-fit: cover;
}

.business-boxing{
  background:rgba(256, 256, 256, 1);
}

.business-border{
  padding-top: 126px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.active{
  opacity: 0.5;
}

.images-div{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.images {
  margin: 60px 0 60px 0;
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media only screen and (min-width: 768px) and (max-width: 976px) {
  .images {
    margin: 60px 0 60px 0;
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.menus{
  width: 197px;
  height: 736px;
  background: #E60012;
}

.menu-item-div{
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 141px;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 18px;
}

.menu-text{
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  font-size: 1rem;
}

.menu-line{
  margin-left: 30px;
  width: 22px;
  height: 1px;
  background-color: #F1F2F5;
}

.content-container{
  height: 736px;
  background: #F1F2F5;
}

.loop-img{
  height: 449px;
  width: 100%;
}

.loop-img img{
  width: 100%;
  height: 100%;
}

.article-container{
  height: auto;
  min-height: 600px;
  width: 1000px;
  padding-bottom: 40px;
}

.title{
  flex: 1;
  font-weight: 500;
  font-size: 1.125rem;
  color: #383838;
  line-height: 28px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
}

@media only screen and (min-width: 768px) and (max-width: 976px) {
  .title{
    font-size: 1rem;
    line-height: 20px;
  }
}

.time{
  min-width: 120px;
  font-weight: 400;
  font-size: 1.125rem;
  color: #383838;
  line-height: 1.8rem;
  text-align: right;
}

@media only screen and (min-width: 768px) and (max-width: 976px) {
  .time{
    font-size: 18px;
    line-height: 15px;
    min-width: 100px;
  }
}

.title-container{
  padding: 18px 0 0 18px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  cursor: pointer;
}

@media only screen and (min-width: 768px) and (max-width: 976px) {
  .title-container{
    padding: 24px 0 0 8px;
  }
}

.article-text{
  padding: 36px 0 0 37px;
  font-weight: 400;
  font-size: 1.25rem;
  color: #383838;
  line-height: 35px;
}

@media only screen and (min-width: 768px) and (max-width: 976px) {
  .article-text{
    padding: 18px 0 0 8px;
    font-size: 18px;
    color: #383838;
    line-height: 35px;
  }
}

.pagination-div{
  justify-items: center;
  align-items: center;
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f5f5f5;
  color: #409EFF;
}

::v-deep .el-pager li{
  font-size: 1rem;
}

.empty-text{
  font-size: 1rem;
}

.title:hover{
  text-decoration: underline;
}

/* 手机端响应式优化 - 只影响手机浏览器 */
@media (max-width: 768px) {
  /* 防止移动端横向滚动 */
  .app-container {
    width: 100%;
    overflow-x: hidden;
    box-sizing: border-box;
  }
  /* 内容容器适配手机屏幕 */
  .business-boxing{
    padding: 0 10px; /* 添加内边距防止内容紧贴屏幕边缘 */
    box-sizing: border-box;
  }
  .business-border{
    padding-top: 15px;
  }
  .images-div{
    margin-top: 20px;
    width: 100%;
  }
  .images {
    width: 100%;
    margin: 20px 0 40px 0;
  }
  /* 移动端菜单适配 */
  .menus{
    width: 85px;
    height: 368px;
  }
  .menu-item-div{
    font-size: 6px;
    color: #FFFFFF;
    line-height: 9px;
    height: 70px;
  }
  .menu-text{
    margin-right: 5px;
    font-size: 0.5rem;
  }
  .menu-line{
    margin-left: 10px;
    width: 10px;
    height: 2px;
  }
  /* 内容区域自适应高度 */
  .content-container{
    height: auto;
  }
  /* 图片自适应 */
  .loop-img{
    height: auto;
  }
  .loop-img img{
    width: 100%;
    height: auto;
    max-width: 100%;
  }
  /* 文章容器适配 */
  .article-container{
    height: auto;
    width: 100%;
    padding: 0 5px;
    box-sizing: border-box;
  }
  /* 标题区域优化 */
  .title{
    width: auto;
    flex: 1;
    font-size: 0.9rem;
    line-height: 20px;
    margin-right: 10px;
  }
  /* 时间区域优化 */
  .time{
    font-size: 0.75rem;
    line-height: 1.2rem;
    padding: 0;
    white-space: nowrap;
  }
  /* 标题容器改为垂直排列 */
  .title-container{
    padding: 10px 5px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }
  .title-container .time {
    margin-top: 5px;
  }
  /* 文章文本优化 */
  .article-text{
    padding: 10px 10px 20px;
    font-size: 0.875rem;
    line-height: 1.5rem;
  }
  /* 分页组件优化 */
  .pagination-div{
    margin-top: 20px;
    margin-bottom: 20px;
  }
  ::v-deep .el-pagination.is-background.el-pagination--small .el-pager li{
    margin: 0;
    padding: 0 1.5px;
  }

  ::v-deep .el-pager li{
    font-size: 0.75rem;
  }
  /* 空数据提示优化 */
  .empty-text{
    font-size: 0.8rem;
    color: #999999;
    text-align: center;
    padding: 20px;
  }
}
</style>
